"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Evaporate = require("evaporate");
var SparkMD5 = require("spark-md5");
var js_sha256_1 = require("js-sha256");
var types_1 = require("./types");
var Worker = (function () {
    function Worker() {
        var _this = this;
        this.listenToEvents = function () {
            self.onmessage = function (_a) {
                var data = _a.data;
                return __awaiter(_this, void 0, void 0, function () {
                    var type, id, config, _b, augmentedConfig, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                type = data.type, id = data.id, config = data.config;
                                _b = type;
                                switch (_b) {
                                    case types_1.WorkerMessages.CANCEL: return [3, 1];
                                    case types_1.WorkerMessages.UPLOAD: return [3, 2];
                                    case types_1.WorkerMessages.CONFIG: return [3, 4];
                                }
                                return [3, 5];
                            case 1:
                                if (this.evaporate)
                                    this.evaporate.cancel(id);
                                else
                                    console.error('Cannot cancel, evaporate not initialised');
                                return [3, 5];
                            case 2:
                                this.signHeaders = __assign({}, config.signHeaders);
                                augmentedConfig = this.augmentConfig(config);
                                _c = this;
                                return [4, Evaporate.create(augmentedConfig)];
                            case 3:
                                _c.evaporate = _d.sent();
                                this.upload(data);
                                return [3, 5];
                            case 4:
                                this.signHeaders = __assign({}, config.signHeaders);
                                return [3, 5];
                            case 5: return [2];
                        }
                    });
                });
            };
        };
        this.upload = function (_a) {
            var config = _a.config, files = _a.files, fileMeta = _a.fileMeta;
            files.forEach(function (_a, index) {
                var file = _a.file, data = _a.data, _b = _a.data, name = _b.path, bucket = _b.bucketName;
                return __awaiter(_this, void 0, void 0, function () {
                    var id, cancelId, formattedConfig, awsObjectKey, reason_1;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                id = fileMeta[index];
                                cancelId = bucket + "/" + name;
                                formattedConfig = {
                                    name: name,
                                    file: file,
                                    bucket: bucket,
                                    progress: function (progress) { return postMessage({ type: types_1.WorkerMessages.PROGRESS, progress: progress, id: id }); },
                                    contentType: config.sendFileContentType ? file.type : undefined,
                                };
                                postMessage({ type: types_1.WorkerMessages.START, id: id, cancelId: cancelId });
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 3, , 4]);
                                return [4, this.evaporate.add(formattedConfig)];
                            case 2:
                                awsObjectKey = _c.sent();
                                postMessage({ type: types_1.WorkerMessages.SUCCESS, id: id, data: data, awsObjectKey: awsObjectKey });
                                return [3, 4];
                            case 3:
                                reason_1 = _c.sent();
                                postMessage({ type: types_1.WorkerMessages.ERROR, reason: reason_1, id: id });
                                return [3, 4];
                            case 4: return [2];
                        }
                    });
                });
            });
        };
        this.augmentConfig = function (config) { return (__assign({}, config, { cryptoMd5Method: function (data) { return btoa(SparkMD5.ArrayBuffer.hash(data, true)); }, cryptoHexEncodedHash256: function (data) {
                var hash = js_sha256_1.sha256.create();
                hash.update(data);
                return hash.hex();
            }, signHeaders: Object.keys(config.signHeaders)
                .reduce(function (headers, key) {
                var _a;
                return __assign({}, headers, (_a = {}, _a[key] = function () { return _this.signHeaders[key]; }, _a));
            }, {}) })); };
        this.evaporate = null;
        this.listenToEvents();
    }
    return Worker;
}());
exports.default = new Worker();
